import { Authority } from '@/shared/security/authority';
import Vue from 'vue';
import Component from 'vue-class-component';
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);
import Router from 'vue-router';

const Home = () => import('@/core/home/home.vue');
const Error = () => import('@/core/error/error.vue');
import admin from '@/router/admin.ts';
import entities from '@/router/entities.ts';
import pages from '@/router/pages.ts';

// Custom elements
const BandejaEntradaComponent = () => import('../bandeja-entrada/bandeja-entrada.vue');
const OperadorSolicitud = () => import('../operador-solicitud/operador-solicitud.vue');
const InformacionSolicitud = () => import('../operador-solicitud/informacion-solicitud/informacion-solicitud.vue');
const FirmaDocumento = () => import('../firma-documento/firma-documento.vue');
const DocumentoFormalizacion = () => import('../documento-formalizacion/documento-formalizacion.vue');
const Contacto = () => import('../contacto/contacto.vue');
const ProcesoFormalizacion = () => import('../proceso-formalizacion/proceso-formalizacion.vue');

Vue.use(Router);

// prettier-ignore
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Error,
      meta: { error403: true }
    },
    {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: Error,
      meta: { error401: true }
    },
    {
      path: '/not-found',
      name: 'NotFound',
      component: Error,
      meta: { error404: true }
    },
    {
      path: '/bandeja-entrada',
      name: 'BandejaEntradaComponent',
      component: BandejaEntradaComponent,
      meta: { authorities: [Authority.INTERNAL_USER, Authority.EXTERNAL_USER] }
    },
    {
      path: '/bandeja-entrada/:estadoFormalizacion',
      name: 'BandejaEntradaComponentSelected',
      component: BandejaEntradaComponent,
      meta: { authorities: [Authority.INTERNAL_USER] }
    },
    {
      path: '/firma-documento/:proyectoClave/documento/:tipoDocumento',
      component: FirmaDocumento,
      meta: { authorities: [Authority.COORDINADOR, Authority.DIRECTOR, Authority.EXTERNAL_USER,
        Authority.SECRETARIO_ADMON, Authority.SECRETARIO_TEC,
        Authority.SNI] }
    },
    {
      path: '/proceso-formalizacion/',
      component: ProcesoFormalizacion,
      meta: { authorities: [Authority.EXTERNAL_USER] }
    },
    {
      path: '/proceso-formalizacion/:proyectoClave',
      component: ProcesoFormalizacion,
      meta: { authorities: [Authority.EXTERNAL_USER] }
    },
    {
      path: '/proyecto/:proyectoClave',
      component: OperadorSolicitud,
      meta: { authorities: [Authority.OPERADOR] },
      children: [
        {
          path: 'documento/:tipoDocumento',
          name: 'documentoFormalizacion',
          component: DocumentoFormalizacion,
          meta: { authorities: [Authority.OPERADOR] }
        },
        {
          path: 'operar',
          name: 'operadorSolicitud',
          component: InformacionSolicitud,
          meta: { authorities: [Authority.OPERADOR] }
        }]
    },
    {
      path: '/contacto',
      component: Contacto
    },
    ...admin,
    ...entities,
    ...pages
  ]
});
